export default __webpack_public_path__ + "static/media/globe.05645f3b.svg";